export default __webpack_public_path__ + "static/media/Brighter-PKlgg.85ff65b6.woff2";